/**
 * Simple email validation using regex
 * For production, consider using a library like zod or validator.js
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validates email and returns result with optional error message
 */
export function validateEmail(email: string): {
  valid: boolean;
  error?: string;
} {
  if (!email.trim()) {
    return { valid: false, error: 'Email cannot be empty' };
  }

  if (!isValidEmail(email)) {
    return { valid: false, error: 'Please enter a valid email address' };
  }

  return { valid: true };
}

/**
 * Validates command input
 */
export function validateCommand(command: string): {
  valid: boolean;
  error?: string;
} {
  if (!command.trim()) {
    return { valid: false, error: 'Command cannot be empty' };
  }

  if (command.length > 1000) {
    return { valid: false, error: 'Command is too long (max 1000 characters)' };
  }

  return { valid: true };
}
